import { Group } from '@cometchat/chat-sdk-javascript';
import { CometChatUIKitConstants } from '../constants/CometChatUIKitConstants';
import { useEffect, useState } from 'react';

type GroupMetaData = {
  muted?: boolean;
};

type GroupState = {
  isAdmin?: boolean;
  isMutedGroup?: boolean;
};

export const useGroup = (group?: Group) => {
  const [groupState, setGroupState] = useState<GroupState>({});

  useEffect(() => {
    if (!group || !group.getGuid) {
      return
    }

    const metadata: GroupMetaData = group.getMetadata() || {};

    const isAdmin =
      group.getScope() === CometChatUIKitConstants.groupMemberScope.admin ||
      group.getScope() === CometChatUIKitConstants.groupMemberScope.owner;

    const isMutedGroup = metadata.muted;
    const state = {
      isAdmin,
      isMutedGroup,
    };

    setGroupState(state);
  }, [group]);

  return {
    groupState,
  };
};
